export const pushModalState = function(nameOfModal: string): void {
  if (!history.state?.nameOfModal?.includes(nameOfModal)) {
    history.pushState({ nameOfModal }, 'Popup', `#${nameOfModal}`);
  }
};

export const popstateEventHandler = function(
  nameOfModal: string,
  callback: () => void
): () => void {
  const onPopstate = (event: PopStateEvent) => {
    if (!(event.state?.nameOfModal?.includes(nameOfModal))) {
      callback();
    }
  };

  window.addEventListener('popstate', onPopstate);

  return () => {
    window.removeEventListener('popstate', onPopstate);
  };
};

export const closeModal = function(): void {
  setTimeout(() => removeHashFromUrl(), 50);
};

const removeHashFromUrl = () => {
  const url = new URL(window.location.href);
  if (/^#.+/.test(url.hash)) {
    url.hash = '';
    history.pushState({}, document.title, url.pathname + url.search);
  }
};

